import React from 'react';
import { motion } from 'framer-motion';

const FundingSection = ({ title, text }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-gray-50 rounded-xl p-6"
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {title}
      </h2>
      <p className="text-gray-600 mb-4 whitespace-pre-line">
        {text}
      </p>
    </motion.div>
  );
};

export default FundingSection;